export const colors = {
  BACKGROUND_COLOR: "#fff8f0",
  SATURDAY_COLOR: "#3A72FF",
  SUNDAY_COLOR: "#FF6F42",
  GRAY: "#fafafa",
  BLACK: "#000000",
  WHITE: "#FFFFFF",
  PRIMARY_MAIN: "",
  PRIMARY_BG_COLOR: "",
  BG_COLOR: "",
  NEUTRAL_100: "",
  NEUTRAL_70: "",
  NEUTRAL_50: "",
  NEUTRAL_20: "",
  DEFAULT_FONT_COLOR: "#53524f",
  DEFAULT_BORDER_COLOR: "#DFDFDF",
  SNACKBAR_BG: "",
  SNACKBAR_FONT: "#fff",
  SNACKBAR_ACTION: "#000",
  TABLE_FONT: "#000",
};
